import setDummyFormValue from "../utils/setDummyFormValue";
import mobileNavDrawer from "../utils/mobileNavDrawer";
import smoothScrollingOnPageAnchors from "./functions/smoothScroll";
import validateCompanyUrlUniqueness from "./functions/validateCompanyUrl";
import initializePlanCards from "../utils/initializePlanCards";
import initializeCollapsiblePlanRows from "../utils/initializeCollapsiblePlanRows";
import initializeUserAttributeCharts from "./functions/initializeUserAttributeCharts";
import initializeNumberAnimation from "../utils/initializeNumberAnimation";
import initializeSpHoverDesc from "./functions/initializeSpHoverDesc";
import initializePlanAccordion from "../utils/initializePlanAccordion";

if (document.body.matches('.registrations.new') || document.body.matches('.registrations.create')) {
  setDummyFormValue();
  validateCompanyUrlUniqueness();
  initializePlanCards();
  initializeCollapsiblePlanRows();
  initializeUserAttributeCharts();
  initializeNumberAnimation();
  initializePlanAccordion();

  // FAQアコーディオン機能
  document.querySelectorAll('.jsFaqQuestion').forEach(question => {
    question.addEventListener('click', () => {
      const item = question.closest('.jsFaqItem');
      const answer = item.querySelector('.jsFaqAnswer');
      const icon = question.querySelector('.jsToggleIcon');

      if (answer.classList.contains('open')) {
        answer.classList.remove('open');
        icon.classList.remove('open');
        item.classList.remove('open');
      } else {
        answer.classList.add('open');
        icon.classList.add('open');
        item.classList.add('open');
      }
    });
  });
}

if (document.body.matches('.registrations.job_new')) {
  setDummyFormValue();
  validateCompanyUrlUniqueness();
  smoothScrollingOnPageAnchors();
}

if (document.body.matches('.registrations.sp.new') || document.body.matches('.registrations.sp.create')) {
  mobileNavDrawer();
  smoothScrollingOnPageAnchors();
  initializeSpHoverDesc();

  const menuToggle = document.querySelector('.jsMenuToggle');
  const headerNav = document.querySelector('.jsHeaderNav');

  if (menuToggle && headerNav) {
    menuToggle.addEventListener('click', () => {
      headerNav.classList.toggle('active');
      menuToggle.classList.toggle('active');
    });

    headerNav.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        headerNav.classList.remove('active');
        menuToggle.classList.remove('active');
      });
    });
  }
}

if (document.body.matches('.registrations.sp.job_new')) {
  mobileNavDrawer();
}
